module.exports = __webpack_public_path__ + "img/mpos-md.07d1027e.svg";